<template>
  <div class="small">
    <line-chart v-if="loaded" :chart-data="datacollection"></line-chart>
    <button @click="fillData()">Randomize</button>
  </div>
</template>

<script>
  import LineChart from './LineChart.js'
  var loaded = false;
  var colors = ["#92D050", "#12AEF5", "#EFA919", "#8B9EB5", "#5A81A6", "#B6E874"]

  export default {
    name:"simple-line-chart",
    components: {
      LineChart
    },
    data() {
      return {
        datacollection: null,
        loaded,
        colors
      }
    },
    mounted() {
      this.fillData()
    },
    methods: {
      fillData() {
        this.datacollection = {
          labels: [this.getRandomInt(), this.getRandomInt()],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }, {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }
          ]
        }
        this.loaded = true;
      },
      getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },

      setData(data) {
        this.datacollection = data;
      },
    }
  }
</script>

<style scoped>
  .small {
    max-width: 600px;
    margin: 150px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/simple-line-chart.vue